<div class="container">
  <h2>Prislistor</h2>

  <div class="top-wrapper" >
    <!-- Warning features without a price -->
    @if (unpricedItems) {
      <div class="warning-wrapper">
        <div class="warning-header">
          <mat-icon>report_problem</mat-icon>
          <strong>Det finns prislistor som är nära slutdatum eller artiklar som saknar pris!</strong>
        </div>
        <ul>
          @for (feature of missingFeaturePrices; track feature) {
            <li>{{feature}}</li>
          }
        </ul>
      </div>
    }

    <!-- Create + copy buttons -->
    @if (isAdmin) {
      <div class="buttons-wrapper">
        <button class="button slim with-icon" (click)="openCreatePricelistModal()"><mat-icon>add</mat-icon> Skapa
      prislista</button>
      <button class="button slim with-icon" (click)="openCopyPricelistModal()">
        <mat-icon class="content-copy-icon">content_copy</mat-icon> Kopiera prislista
      </button>
    </div>
  }
</div>


@if (dataSource$) {
  <mat-table [dataSource]="dataSource$">
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef> Id </mat-header-cell>
      <mat-cell *matCellDef="let pricelist"> {{ pricelist.priceListId }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef> Namn </mat-header-cell>
      <mat-cell *matCellDef="let pricelist"> {{ pricelist.name }} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="validFrom">
      <mat-header-cell *matHeaderCellDef> Giltig från </mat-header-cell>
      <mat-cell *matCellDef="let pricelist"> {{formatDate(pricelist.validFrom)}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="validTo">
      <mat-header-cell *matHeaderCellDef> Giltig till </mat-header-cell>
      <mat-cell *matCellDef="let pricelist">
        {{pricelist.validTo ? formatDate(pricelist.validTo) : 'Tillsvidare'}}
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" class="clickable"
    (click)="navigateToPriceListById(row.priceListId)"></mat-row>
  </mat-table>
}
</div>